import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsSearchWrapper = styled.div`
  max-width: 400px;
  margin-left: ${Spacing.S12};

  &:first-of-type {
    margin-left: 0;
  }
`
